import { createContext, useContext, useState, ReactNode } from 'react';

/** Opção de um dropdown (ex.: Exportar > Excel, PDF) */
export interface BreadcrumbDropdownOption {
  label: string;
  onClick: () => void;
}

/** Uma ação em um slot do breadcrumb (Ação Primária, Secundária, Imprimir/Exportar ou Histórico) */
export interface BreadcrumbAction {
  label: string;
  onClick: () => void;
  href?: string;
  /** Ex.: 'primary' para botão de destaque (ex.: Cadastrar) no breadcrumb */
  variant?: 'primary';
  /** Se definido, renderiza dropdown com estas opções (ex.: Exportar > Excel, PDF) */
  dropdownOptions?: BreadcrumbDropdownOption[];
}

/** Ordem fixa: Ação Primária, Ação Secundária, Imprimir, Histórico (até 4 botões) */
export interface BreadcrumbActionsConfig {
  primary?: BreadcrumbAction;
  secondary?: BreadcrumbAction;
  print?: BreadcrumbAction;
  history?: BreadcrumbAction;
}

interface BreadcrumbActionsContextType {
  actions: BreadcrumbActionsConfig;
  setActions: (actions: BreadcrumbActionsConfig) => void;
}

export const BreadcrumbActionsContext = createContext<BreadcrumbActionsContextType | undefined>(undefined);

export function BreadcrumbActionsProvider({ children }: { children: ReactNode }) {
  const [actions, setActions] = useState<BreadcrumbActionsConfig>({});

  return (
    <BreadcrumbActionsContext.Provider value={{ actions, setActions }}>
      {children}
    </BreadcrumbActionsContext.Provider>
  );
}

export function useBreadcrumbActions() {
  const context = useContext(BreadcrumbActionsContext);
  if (!context) {
    throw new Error('useBreadcrumbActions must be used within BreadcrumbActionsProvider');
  }
  return context;
}
